module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Communication/Active-call-d89a6ca53c0a5a50257f3c1e95285ac6.svg";